import { apiClient } from './api/apiClient';
import { API_ENDPOINTS } from '../config';
import { PaginatedResponse, ApiResponse } from '../types';

export interface ConsultationRequest {
  id?: string;
  _id?: string;
  data?: {
    'Full Name'?: string;
    Email?: string;
    Phone?: string;
    Message?: string;
    Status?: string;
    Notes?: string;
    'Submitted At'?: string;
  };
}

/**
 * Consultation Request Service
 * Handles customer consultation form submissions via collection API
 */
export class ConsultationService {
  /**
   * Submit consultation request (public, no auth required)
   */
  static async submitConsultationRequest(data: {
    fullName: string;
    email: string;
    phone: string;
    message: string;
  }): Promise<ApiResponse<any>> {
    return apiClient.post<any>(
      API_ENDPOINTS.CONSULTATION_REQUESTS,
      {
        data: {
          'Full Name': data.fullName,
          Email: data.email,
          Phone: data.phone,
          Message: data.message,
          Status: 'new',
          'Submitted At': new Date().toISOString(),
        },
      },
      false
    );
  }

  /**
   * Fetch all consultation requests (admin only)
   */
  static async getAllConsultationRequests(
    page: number = 1,
    limit: number = 10
  ): Promise<ApiResponse<PaginatedResponse<ConsultationRequest>>> {
    const endpoint = `${API_ENDPOINTS.CONSULTATION_REQUESTS}?page=${page}&limit=${limit}`;
    return apiClient.get<PaginatedResponse<ConsultationRequest>>(endpoint, true);
  }

  /**
   * Update consultation request status (admin only)
   */
  static async updateConsultationRequestStatus(
    id: string,
    status: string,
    notes?: string
  ): Promise<ApiResponse<ConsultationRequest>> {
    return apiClient.put<ConsultationRequest>(
      `/api/globals/collection/${id}`,
      { data: { Status: status, ...(notes !== undefined ? { Notes: notes } : {}) } },
      true
    );
  }

  /**
   * Delete consultation request (admin only)
   */
  static async deleteConsultationRequest(
    id: string
  ): Promise<ApiResponse<{ success: boolean }>> {
    return apiClient.delete<{ success: boolean }>(
      `/api/globals/collection/${id}`,
      true
    );
  }
}

export default ConsultationService;
